import React, { useEffect, useRef } from 'react';
import { View } from 'react-native';
import { TWCPage } from '@components';
import { useRecoilValue } from 'recoil';

import { myWeatherPageTestIDs } from '@constants';
import { userSettingsState } from '@store';

import { MyWeatherBottomRow } from './MyWeatherBottomRow/MyWeatherBottomRow';
import { MyWeatherMiddleRow } from './MyWeatherMiddleRow/MyWeatherMiddleRow';
import { MyWeatherTopRow } from './MyWeatherTopRow/MyWeatherTopRow';
import { styles } from './styles';

import { segmentEventTypes } from '../../components/segment/segmentEventTypes';
import { segmentTrackEvent } from '../../components/segment/SegmentTrackEvent';

export const MyWeatherPage = () => {
  const segmentCityOverviewFired = useRef(false);
  const userSettings = useRecoilValue(userSettingsState);

  useEffect(() => {
    if (!segmentCityOverviewFired.current) {
      // Send the location they confirmed in the modal
      segmentTrackEvent(segmentEventTypes.CITY_OVERVIEW, userSettings);
      segmentCityOverviewFired.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [segmentCityOverviewFired]);

  return (
    <TWCPage
      childIds={[
        myWeatherPageTestIDs.liveVideoPlayerTile,
        myWeatherPageTestIDs.liveMapTile,
        myWeatherPageTestIDs.currentWeatherConditionsTile,
        myWeatherPageTestIDs.hourlyForecastTile,
        myWeatherPageTestIDs.dailyForecastTile,
        myWeatherPageTestIDs.changeCityButton,
      ]}
      firstFocus={myWeatherPageTestIDs.liveVideoPlayerTile}
      isMenuItem
      pageID={myWeatherPageTestIDs.myWeatherPage}
    >
      <View style={styles.wrapper}>
        <MyWeatherTopRow />
        <MyWeatherMiddleRow />
        <MyWeatherBottomRow />
      </View>
    </TWCPage>
  );
};
